import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { SignedOutPage } from '@/features/auth/signed-out-page';

const searchSchema = z.object({
  state: z.string().max(200).optional(),
});

/**
 * Public: KorOS sends the browser here after single sign-out
 * (`post_logout_redirect_uri`). Never redirects into sign-in by itself — that
 * would sign the person straight back in through KorOS SSO.
 */
export const Route = createFileRoute('/signed-out')({
  validateSearch: searchSchema,
  component: SignedOutPage,
});
